
import WatermarkManager from './watermarkManager';
import WatermarkDetail from './watermarkDetail'
export {
    WatermarkManager,
    WatermarkDetail
}